import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { MouseEvent } from './column-filter.types';

interface Props {
  anchor: Element | null;
  columns: { header: string; accessor: string }[];
  categoryMenu: boolean;
  onClose: () => void;
  onSelectColumn: (event: MouseEvent) => void;
}

const ColumnFilterMenu: React.FC<Props> = ({ ...props }) => (
  <Menu
    anchorEl={props.anchor}
    open={props.categoryMenu}
    onClose={props.onClose}
  >
    {props.columns.map((col) => (
      <MenuItem
        key={col.header + col.accessor}
        onClick={props.onSelectColumn}
        data-filter-category={col.accessor}
      >
        {col.header}
      </MenuItem>
    ))}
  </Menu>
);

export default ColumnFilterMenu;
